/*
function($state) {
          if($state.current.data)
            Object.keys($state.current.data).map(d => {
              console.log('mapping ', d);
              this[d] = $state.current.data[d];
            });
          this.onselection = s => {
            console.log('onselection called', s);
            this.selected = s;
          }
          this.sethelpers = h => {
            Object.keys(h).forEach(k => this[k] = h[k]);
            console.log('helpers set');
          }
          this.setsysvars = s => {
            this.sysvars = s;
            console.log('sysvars set');
          }
        }
*/

/* @ngInject */
export default function ($rootScope, $state, $uibModal, ngToast, Sysvars, AppConfig) {
    this.formHooks = {};
    this.selected = null;
    this.sysvars = {};

    Object.keys($state.current.data || {}).map(d => this[d] = $state.current.data[d]);

    this.load = () => {
        this.loading = true;
        return Sysvars.load()
            .then(s => {
                this.sysvars = {};
                s.forEach(e => this.sysvars[e._id] = e);
                if (this.keyVal) {
                    this.shadowArr = Object.entries(this.sysvars[this.keyVal].val);
                }
            })
            .catch(err => $rootScope.$emit('generalAlert', 'Error getting system variables: ' + (err)))
            .finally(() => this.loading = false);
    }
    this.load();

    //this.formHooks.setDirtyHook = hook => this.formHooks.setDirty = hook;
    //this.formHooks.isPristineHook = hook => this.formHooks.isPristine = hook;

    this.setFormHooks = hooks => Object.keys(hooks).forEach(hk => this.formHooks[hk] = hooks[hk]);
    this.onselection = s => this.selected = s;

    this.cancel = () => this.load();

    this.save = () => {
        if (this.keyVal)
            this.sysvars[this.keyVal].val = Object.fromEntries(this.shadowArr);

        // first, validate
        let errors = [];
        (this.validate || [])
            .forEach(v => {
                // for each validator
                // scan 'across'
                var r = null;
                (v.across ? _.get(this.sysvars, v.across) : [this.sysvars]).forEach(s => {
                    r = validationFunctions[v.test](_.get(s, v.within), Object.assign({}, v.testParams));
                    if (r)
                        errors.push((v.key ? s[v.key] + ': ' : '') + r);
                });
            })
        // If validation generated an error:
        if (errors.length) {
            $uibModal.open({
                template: require('./validationError.html'),
                controller: function () { this.errors = errors; },
                controllerAs: '$ctrl'
            });
            return Promise.reject('Validation Errors');
        }

        this.loading = true;
        return Promise.all(this.saveVars.map(v => Sysvars.upsert(this.sysvars[v])))
            .then(() => {
                AppConfig.load();
                ngToast.create({ content: '   Saved   ' });
                this.loading = false;
            })
            .catch(err => {
                $rootScope.$emit('generalAlert', 'Error saving: ' + err);
                this.loading = false;
            });
    }

    this.add = function (target, item) {
        if (Array.isArray(target))
            target.push(item);
        else
            Object.assign(target, item);
        this.formHooks.setDirty();
    }

    this.del = (target, item) => {		// deletes item from array by matching.  Item is array element or object key
        $uibModal.open({
            template: require('./deleteConfirmation.html'),
            size: 'sm',
        })
            .result
            .then(() => {
                if (Array.isArray(target))
                    target.splice(target.indexOf(item), 1);
                else
                    delete target[item];
                this.formHooks.setDirty();
            })
            .catch(() => null);
    }
    this.toggle = (arr, item) => {
        if (arr.indexOf(item) >= 0) {
            arr.splice(arr.indexOf(item), 1);
        }
        else
            arr.push(item);
        this.formHooks.setDirty();
    }

    this.epoch = pr => new Date(pr.startDate || "12/31/2099").getTime();

    this.findGroupById = function (id) {
        if (!this.sysvars) return;	// may not be loaded yet.
        return _.find(this.sysvars.productGroups.val, { 'groupId': id });
    }

    // State change management

    this.listener = $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
        //Navigate to state if the form isn't dirty
        if (this.formHooks.pristine()) {
            this.listener();
            return;
        }

        $uibModal.open({
            template: require('./unsavedChanges.html'),
            size: 'sm',
        })
            .result.then(() => {
                this.listener(); //Stop listening for location changes
                $state.go(toState, toParams); //Go to page they're interested in
            })
            .catch(() => null);

        //prevent navigation by default since we'll handle it
        //once the user selects a dialog option
        event.preventDefault();
        return;
    });

    this.$onDestroy = () => {
        if (this.listener)
            this.listener();
    }
}

const validationFunctions = {
    unique: function (arr, testParams) {
        return ((new Set(arr.map(e => e[testParams.field]))).size !== arr.length) ? testParams.fieldDesc + ' must be unique' : null
    },

    noDateOverlap: function (arr, testParams) {
        if (!arr) return false;
        let error = null;
        let a = arr.slice();
        let e;
        while (!error && (e = a.shift()) && a.length) {
            //console.log('checking window',e.startDate,'-',e.endDate);
            let i = 0;
            var esm = moment.tz(e.startDate, 'MM/DD/YYYY', "America/New_York");
            var eem = moment.tz(e.endDate, 'MM/DD/YYYY', "America/New_York").add(1, 'd');
            error = _.find(a, function (te) {
                //console.log('...against',te.startDate,'-',te.endDate);
                var s = moment.tz(te.startDate, 'MM/DD/YYYY', "America/New_York");
                var e = moment.tz(te.endDate, 'MM/DD/YYYY', "America/New_York").add(1, 'd');
                return ((esm.isAfter(s) && esm.isBefore(e)) || (eem.isAfter(s) && eem.isBefore(e)));
            }) ? 'Date ranges must not overlap (' + e.startDate + '-' + e.endDate + ')' : null
        }
        return error;
    }
}